import { Form, Input } from 'antd';

export const PaymentCommentInput = (): JSX.Element => {
    return (
        <Form.Item label='Comment' name='comment'>
            <Input.TextArea rows={5} style={{ resize: 'none' }} placeholder='Leave a comment' />
        </Form.Item>
    );
};
